import { compose } from 'ramda'
import { withAnalytics } from 'hocs/withAnalytics'
import withAuth from 'hocs/withAuth'
import { withCookies } from 'hocs/withCookies'
import { withGql } from 'hocs/withGql'
import withVertical from 'hocs/withVertical'
import { CompanyJobsPage } from 'containers/company-jobs/page'

export default compose(
    withGql({}),
    withAuth({
        isPublicPage: true,
    }),
    withVertical,
    withCookies,
    withAnalytics({ pageNameForAnalytics: 'Company Jobs' }),
)(CompanyJobsPage)
